import { LucideIcon } from 'lucide-react';

export interface Service {
  id: string;
  slug: string;
  title: string;
  description: string;
  icon: LucideIcon;
  features: string[];
  details?: string;
  hero_image?: string;
  allow_attachments?: boolean;
}

export interface Differential {
  id: string;
  title: string;
  description: string;
  icon: LucideIcon;
}

export interface Testimonial {
  id: string;
  name: string;
  role: string;
  content: string;
}

export interface ProcessStep {
  id: string;
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
}

export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export interface ChatMessage {
  role: 'user' | 'model';
  text: string;
  isError?: boolean;
}

export enum SectionId {
  HOME = 'home',
  ABOUT = 'about',
  SERVICES = 'services',
  PROCESS = 'process',
  TESTIMONIALS = 'testimonials',
  FAQ = 'faq',
  CONTACT = 'contact',
  FEEDBACK = 'feedback',
}